
// class ListNode {
//     constructor(key, value) {
//       this._key = key
//       this._value = value
//       // this._next = null;  //记录插入顺序
//       this._ne = null //记录Hash碰撞后的结点
//     }
// }
function ListNode(key, value){
  this._key = key
  this._value = value
  // this._next = null;  //记录插入顺序
  this._ne = null //记录Hash碰撞后的结点
}
function myMap(){
  this.init()
}

myMap.prototype.init = function() {
  this.collection = new Array(6) //map底层用了hash算法。假如使用collection容器存放map中的数据
  for (let i = 0; i < this.collection.length; i++) {
    this.collection[i] = Object.create(null)
    this.collection[i]._ne = null
  }
}
myMap.prototype.set = function(key, value) {
  let index = this.hash(key) //获取容器中的位置
  let node = this.collection[index] //获得index位置处的对象
  while (node._ne) {
    if (node._ne._key === key) {
      node._ne._value = value //更新
      return this //注意返回当前对象this
    } else {
      node = node._ne
    }
  }
  //map中没有该key，就在链表尾部插入
  node._ne = new ListNode(key, value)
  return this //注意返回当前对象this
}

myMap.prototype.hash = function(key) {
  let index = 0
  if (typeof key === 'string') {
    //字符串的话取前10位，也没必要全部遍历完字符串，会影响性能、计算时间
    for (let i = 0; i < 10; i++) {
      index += isNaN(key.charCodeAt(i)) ? 0 : key.charCodeAt(i)
    }
  } else if (typeof key === 'number') {
    index = isNaN(key)
      ? this.collection.length - 1
      : key % this.collection.length
  } else if (typeof key === 'object') {
    //    如果传入的是一个对象作为键，es6中的Map，底层Hash算法一定跟它的内存地址有关，因为取值时，比较的是是否是同一个引用。就算给了一个字面量相同的值，也不能取到值，必须试试引用相同的值才能取到
    //    这里我只能模拟key为对象时，经Hash算法得到的都是index=0了
    index = 0
  } else if (typeof key === 'undefined') {
    index = 1
  } else if (typeof key === 'boolean') {
    index = 2
  }
  return index % this.collection.length
}

myMap.prototype.get = function(key) {
  let index = this.hash(key)
  let node = this.collection[index] //获取容器相应位置处的对象
  while (node) {
    if (node._key === key) {
      return node._value
    } else {
      node = node._ne
    }
  }
  return undefined
}

// class myMap {
//     // collection: any
//     constructor() {
//       this.init()
//     }
    
// }
  
export default myMap
  
